/* projects/fitnessforservice/src/app/assessments/local-metal-loss-profile-data/local-metal-loss-profile-data.component.css */
.smaller-table th,
.smaller-table td {
  width: 5px;
  padding: 8px;
}
.smaller-table tr {
  height: 20px;
  width: 5px;
}
.smaller-table td input {
  height: 25px;
  width: 65px;
}
.smaller-table td mat-checkbox {
  height: 10px;
  width: 10px;
}
/*# sourceMappingURL=local-metal-loss-profile-data.component-4SXQFJWV.css.map */
